import createReactComponent from '../createReactComponent';
export default createReactComponent('map-code', 'IconMapCode', [
  ['path', { d: 'M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v9', key: 'svg-0' }],
  ['path', { d: 'M9 4v13', key: 'svg-1' }],
  ['path', { d: 'M15 7v6.5', key: 'svg-2' }],
  ['path', { d: 'M20 21l2 -2l-2 -2', key: 'svg-3' }],
  ['path', { d: 'M17 17l-2 2l2 2', key: 'svg-4' }],
]);
